"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomCallbackBackend = function () {
  function CustomCallbackBackend() {
    _classCallCheck(this, CustomCallbackBackend);

    this.init.apply(this, arguments);
  }

  _createClass(CustomCallbackBackend, [{
    key: "create",
    value: function create() {
      var _options;

      (_options = this.options).customCreate.apply(_options, arguments);
    }
  }, {
    key: "missingCustomCallback",
    value: function missingCustomCallback(callbackType) {
      return function (language, namespace, callback) {
        return callback(new Error("You must provide a \"custom" + callbackType + "\" option with the " + "\"CustomCallbackBackend\"."));
      };
    }
  }, {
    key: "init",
    value: function init(services) {
      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
      var i18nextOptions = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

      this.options = _extends({
        customCreate: function customCreate() {},
        customLoad: this.missingCustomCallback("Load"),
        customLoadMulti: this.missingCustomCallback("LoadMulti")
      }, i18nextOptions, options);
    }
  }, {
    key: "read",
    value: function read() {
      var _options2;

      (_options2 = this.options).customLoad.apply(_options2, arguments);
    }
  }, {
    key: "readMulti",
    value: function readMulti() {
      var _options3;

      (_options3 = this.options).customLoadMulti.apply(_options3, arguments);
    }
  }]);

  return CustomCallbackBackend;
}();

CustomCallbackBackend.type = "backend";
exports.default = CustomCallbackBackend;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/i18next-callback-backend/lib/index.js
// module id = 1188
// module chunks = 6